import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_SWITCH_ACTIVATE_FY);

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {

}

const actions = {

    async create({ commit }, payload) {
        //console.log("[state/organisation/utility/managefinancialyear/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            //console.log("[state/organisation/utility/managefinancialyear/create] res: ", res);
            if (res.status == 200 || res.status == 201) {
                
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async activateFY({ commit }, payload) {
        //console.log("[state/organisation/utility/managefinancialyear/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            //console.log("[state/organisation/utility/managefinancialyear/create] res: ", res);
            if (res.status == 200 || res.status == 201) {
                
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}